<template>
  <v-container>
    <div v-if="!$store.state.globalLoading">
      <v-row wrap>


        <v-flex xs12 sm8 class="pa-3">
          <v-row>
            <v-flex xs8 class="pl-3">
              <span class="headline">
                Decks

                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <span class="hover caption ml-2" color="grey" dark  v-on="on">
                      Sort: {{sort.name}}
                    </span>
                  </template>
                  <v-list>
                    <div
                      v-for="(item, index) in sortOptions"
                      :key="index"
                      @click="sort = item"
                    >
                      <div class="pa-2 hover">{{ item.name }}</div>
                    </div>
                  </v-list>
                </v-menu>



              </span>

            </v-flex>
            <v-flex xs4 class="text-right pr-3 pt-1">
              <v-btn
              right
                dark
                small
                outlined
                color="blue lighten-1"
                @click="$router.push({name:'Browse'})"
                >Library
                <v-icon>
                  mdi-bookshelf
                </v-icon>

              </v-btn>

            </v-flex>
          </v-row>


          <v-card
            flat
            outlined
            class="round-card pa-3 my-2"
            v-if="$store.getters.decksForHome.length == 0"

          >
          <v-icon large color="blue">
            mdi-bookshelf
          </v-icon>
          Add your first deck by visiting the library above.

          </v-card>

          <v-card
            flat
            ripple
            outlined
            class="round-card pa-3 my-2"
            v-for="(deck, i) in sortedDecks"
            :key="i"
            @click="$router.push({ name: 'Learn', params: {id: deck.id} })"
            >
            <v-row wrap class="ml-2">
              <v-flex xs12 md6>
                <div class="overline blue--text">

                    {{deck.subject}} | {{deck.lectureDate}}
                </div>
                <div class="body-1">
                  {{deck.name}}
                </div>
              </v-flex>
              <v-flex xs2 md1>
                <div class="overline grey--text">
                  Cards
                </div>
                <div>
                  {{deck.deckLength}}
                </div>
              </v-flex>
              <v-flex xs3 md1>
                <div class="overline grey--text">
                  Round
                </div>
                <div>
                  {{$store.getters.homeDeckTimesPracticed(deck.id)}}
                </div>
              </v-flex>
              <v-flex xs3 md2>
                <div class="overline grey--text">
                  Assess
                </div>
                <div>
                  {{$store.getters.homeDeckLastAssessment(deck.id)}}%

                </div>
              </v-flex>
              <v-flex xs3 md2>
                <div class="overline grey--text">
                  Last Pract
                </div>
                <div>
                  <v-chip dark small :color="$store.getters.homeDeckLastPracticed(deck.id).color">
                    {{$store.getters.homeDeckLastPracticed(deck.id).text}}
                  </v-chip>
                </div>
              </v-flex>



            </v-row>
            <v-row>
            </v-row>
          </v-card>


        </v-flex>

        <v-flex xs12 sm4 class="pa-3">

          <div>
            <p class="headline">Today's Progress</p>
            <v-card flat outlined class="round-card pa-5">
              <div class="text-center">
                <div class="overline font-weight-regular grey--text">
                  Cards Practiced
                </div>
                <div class="display-1 font-weight-light blue--text">
                  {{todaysCardCount()}}
                </div>
              </div>

              <div class="mt-5 text-center">
                <div class="overline font-weight-regular grey--text">
                  Time Studying
                </div>
                <div class="display-1 font-weight-light blue--text">
                  {{todaysPracticeTime()}}
                </div>
              </div>
            </v-card>

          </div>
          <div>
            <p class="headline mt-5">Prototype Content</p>
            <v-card flat outlined class="round-card pa-5">
              <router-link to="/neuro">Neuroanatomy Images</router-link>
              <br />
              <router-link to="/neuroAtlas">Neuroanatomy Atlas</router-link>
            </v-card>

          </div>
        </v-flex>

      </v-row>
      <dialogTOU />



    </div>












  </v-container>

</template>

<script>
import Obj from '@/objects'
import _ from 'underscore'
import moment from 'moment'
import firebase from 'firebase'
import dialogTOU from '@/components/dialogTOU.vue'
import axios from 'axios'

export default {
  name: 'Dashboard',
  data() {
    return {
      decks: null,
      loading: false,
      newDeck: null,
      sortOptions: [
        {name: 'Last Practice', value: 'lastPractice'},
        {name: 'Assess Score', value: 'assess'},
        {name: 'Rounds of Practice', value: 'rounds'}
      ],
      sort: {name: 'Last Practice', value: 'lastPractice'},


    }
  },
  components: {
    dialogTOU
  },

  computed: {
    sortedDecks() {
      if (this.sort.value == 'lastPractice') {
        let sort = _.sortBy(this.$store.getters.decksForHome, deck => {
          return this.$store.getters.homeDeckLastPracticed(deck.id).value
        })
        return sort.reverse()
      }
      else if (this.sort.value == 'rounds') {
        let sort = _.sortBy(this.$store.getters.decksForHome, deck => {
          return this.$store.getters.homeDeckTimesPracticed(deck.id).value
        })
        return sort

      }
      else if (this.sort.value == 'assess') {
        let sort = _.sortBy(this.$store.getters.decksForHome, deck => {
          return this.$store.getters.homeDeckLastAssessment(deck.id).value / 100
        })
        return sort.reverse()

      }
      else {
        return this.$store.getters.decksForHome
      }
    }


  },

  mounted() {
    //ios Version check

    this.iosUpdate()

    //used to refresh to content after finishign practice. Data initially seeded in App.vue
    if (this.$store.state.initialLoadComplete) {
      this.$store.dispatch('userPracticeHistoryGet')
      this.$store.dispatch('userDailyProgressGet')
    }

  },
  methods: {

    iosUpdate() {
      let url
      if (false) {
        url = 'https://us-central1-omentum-test.cloudfunctions.net/widgets/appVersion'
      }
      else {
        url = 'https://us-central1-omentum-prod.cloudfunctions.net/widgets/appVersion'
      }
      console.log('checking version')
      axios.get(url)
      .then(result => {
        console.log('server:',result.data)
        console.log('local:',result.data)
        if (result.data != this.$store.state.appVersion) {
          let message = JSON.stringify({
            test: 'test'
          })
          this.$iosHandlers.update.postMessage(message)
        }
      })
    },

    //UI Functions
    todaysPracticeTime() {
      let date = moment().format('YYYY-MM-DD')
      if (this.$store.state.userDailyProgress != null && date in this.$store.state.userDailyProgress) {
        //make time in seconds pretty
        return this.UItotalTimeSpent(this.$store.state.userDailyProgress[date].timeSeconds)

      }
      else {
        return '0 min'
      }
    },
    todaysCardCount() {
      let date = moment().format('YYYY-MM-DD')
      if (this.$store.state.userDailyProgress != null && date in this.$store.state.userDailyProgress) {
        //make time in seconds pretty
        return this.$store.state.userDailyProgress[date].cards
      }
      else {
        return 0
      }
    },

    //Also used in Learn
    UItotalTimeSpent(seconds) {
      if (seconds < 60) {
        return seconds + " sec"
      }
      else {
        return Math.round(seconds/60) + " min"
      }
    },


  }
}
</script>

<style>
.hover: {
  cursor: pointer;
}

</style>
